import { BottomSheet } from '@drone-js/core';
import React from 'react';
import SortAndFilterContent from 'component/page/search/SortAndFilter/SortAndFilterContent';
import { SortAndFilterContentVariant } from 'component/page/search/SortAndFilter/SortAndFilterContent.selectors';
import { connect, useDispatch, useSelector } from 'react-redux';
import { OverlayType, selectCategoriesBottomSheetVisible, closeOverlay } from 'store/slice/overlay';
import FilterButtonsStickyFooter from 'component/page/search/SortAndFilter/SortAndFilterOverlay/FilterButtonsStickyFooter';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesCloseBottomSheetClickEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesCloseBottomSheetClickEventActivitiesManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/events';
import { mapDispatchToProps } from 'component/page/search/SortAndFilter/SortAndFilterOverlay/SortAndFilterOverlay.selectors';
import { useLocation, useNavigate } from 'react-router-dom';
import { Sort } from 'gql/autogen/Sort';
import { FilterState } from 'component/common/Filter/Filter.types';
import { getSortAndFilterQueryString } from 'component/page/search/SortAndFilter/sortAndFilterQuery.utils';
import { searchInitialState } from 'component/page/search/store/search';
import { CategoryBottomSheetProps, mapStateToProps } from 'component/page/search/SortAndFilter/CategoryBottomSheet/CategoryBottomSheet.selectors';

const CategoryBottomSheet: React.FC<CategoryBottomSheetProps> = (props) => {
    const isVisible = useSelector(selectCategoriesBottomSheetVisible);
    const dispatch = useDispatch();
    const locationSearch = useLocation().search;
    const navigation = useNavigate();
    const [sortState, setSortState] = React.useState(props.sort);
    const [filterState, setFilterState] = React.useState(props.filter);

    const navigateAndClose = (sorting: Sort, filtering: FilterState) => {
        const query = getSortAndFilterQueryString(locationSearch, sorting, filtering, true);
        navigation(`?${query}`);
        props.onClose();
    };

    const onClearButtonClick = () => {
        props.clearSortAndFilter(SortAndFilterContentVariant.CategoryBottomSheet);
        navigateAndClose(searchInitialState.sort, searchInitialState.filter);
    };

    const onFilterWithSidebarButtonClick = () => {
        props.setSortAndFilter(props.page, sortState, filterState, SortAndFilterContentVariant.CategoryBottomSheet);
        navigateAndClose(sortState, filterState);
    };

    const onChange = (visible: boolean) => {
        if (!visible) {
            props.onClose();
            trackElementEvent<ActivitiesCloseBottomSheetClickEventActivitiesFieldsV1>(ActivitiesCloseBottomSheetClickEventActivitiesManifestV1.ids, {});
            dispatch(closeOverlay(OverlayType.CategoriesBottomSheet));
        }
    };

    return (
        <BottomSheet
            title={props.cms[252193]}
            closeButton={{
                'aria-label': props.cms[126815],
                'data-element-name': 'activities-bottom-sheet-close-button',
            }}
            height="80vh"
            pt="16"
            visible={isVisible}
            onChange={onChange}
        >
            <SortAndFilterContent variant={SortAndFilterContentVariant.CategoryBottomSheet} visible={true} onFilterStateChange={setFilterState} onSortStateChange={setSortState} />
            <FilterButtonsStickyFooter onClearButtonClick={onClearButtonClick} onFilterWithSidebarButtonClick={onFilterWithSidebarButtonClick} cms={props.cms} visible={true} />
        </BottomSheet>
    );
};

CategoryBottomSheet.displayName = 'CategoryBottomSheet';

export default connect(mapStateToProps, mapDispatchToProps)(CategoryBottomSheet);
